module.exports = "/images/Artboard8.png?eb494357c6a91d085daf12611c62e68f";